var shortWeekDayNames = ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'];
var mediumWeekDayNames = ['Zo.', 'Ma.', 'Di.', 'Woe.', 'Do.', 'Vr.', 'Zat.'];
var longWeekDayNames = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
var longMonthNames = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'October', 'November', 'December'];
var shortMonthNames = ['Jan', 'Feb', 'mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'];
var pickerDayList = ['MA', 'DI', 'WO', 'DO', 'VR', 'ZA', 'ZO'];
var data = {
    locale: 'nl',
    otherLocale: 'en',
    otherLocaleLong: 'English',
    pick: (function (choices) { return choices['nl'] || choices['en'] || choices[Object.keys(choices)[0]]; }),
    pickWithLocale: (function (choices, locale) { return choices[locale] || choices[Object.keys(choices)[0]]; }),
    shortWeekDayNames: shortWeekDayNames,
    mediumWeekDayNames: mediumWeekDayNames,
    longWeekDayNames: longWeekDayNames,
    longMonthNames: longMonthNames,
    shortMonthNames: shortMonthNames,
    pickerDayList: pickerDayList,
    formatShortMonthNames: function (d) { return "" + shortMonthNames[d.getMonth()]; },
    formatMediumDayName: function (d) { return "" + mediumWeekDayNames[d.getDay()]; },
    formatShortDay: function (d) { return mediumWeekDayNames[d.getDay()] + " " + d.getDate(); },
    formatMediumDate: function (d) { return mediumWeekDayNames[d.getDay()] + " " + d.getDate() + " " + shortMonthNames[d.getMonth()] + " " + d.getFullYear(); },
    formatLongDate: function (d) { return longWeekDayNames[d.getDay()] + " " + d.getDate() + " " + longMonthNames[d.getMonth()]; },
    formatNumericalYearMonthDate: function (d) { return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate(); },
    formatLongMonthYear: function (d) { return longMonthNames[d.getMonth()] + " " + d.getFullYear(); },
    formatLongDayName: function (d) { return "" + longWeekDayNames[d.getDay()]; },
    formatDateRange: function (d1, d2) { return ((d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()) ?
        mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()
        : (d1.getFullYear() === d2.getFullYear()) ?
            mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " " + shortMonthNames[d1.getMonth()] + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()
            :
                mediumWeekDayNames[d1.getDay()] + " " + d1.getDate() + " " + shortMonthNames[d1.getMonth()] + " " + d1.getFullYear() + " - " + mediumWeekDayNames[d2.getDay()] + " " + d2.getDate() + " " + shortMonthNames[d2.getMonth()] + " " + d2.getFullYear()); },
    // formatTime: (d) => `${(d.getHours()) % 12}:${d.getMinutes().toString().length < 2 ? d.getMinutes().toString() + '0' : d.getMinutes().toString()} ${d.getHours() >= 12 ? 'PM' : 'AM'}`,
    formatTime: function (d) { return d.getHours() + ":" + (d.getMinutes().toString().length < 2 ? '0' + d.getMinutes().toString() : d.getMinutes().toString()); },
    authHome: 'Home',
    authLinksSignIn: 'Log in',
    authLinksForgotPassword: 'Wachtwoord vergeten?',
    authAlreadyHaveAccount: 'Ik heb een account',
    authCreateCompany: 'Maak een Nieuw Bedrijf',
    authAlreadyCompany: 'Bedrijf bestaat al',
    authAlreadyCompanyJoin: 'Word lid van mijn bedrijf met een code.',
    authAlreadyCompanyEnterCode: 'Voer de uitnodigingscode in die je per e-mail of sms hebt ontvangen.',
    authLogin: 'Log in',
    authDownloadApp: 'Log in met de app of download deze van de App Store of Google Play.',
    authExistingAccountTitle: 'Bestaande gebruiker',
    authExistingAccount: 'Er is al een account gekoppeld aan dit e-mailadres of mobiele telefoonnummer.',
    authYouWillJoin: 'Je gaat meedoen',
    authJoin: 'Doe mee',
    authSignYouIn: 'Aanmelden',
    authNewOn: 'Ben je nieuw bij WondAdviseur Letselschade?',
    authWelcomeToGivo: 'Welkom bij WondAdviseur Letselschade',
    authOr: 'of',
    authRegister: 'Maak een account',
    authDiscover: 'Ontdek WondAdviseur Letselschade',
    authLoginWithFacebook: 'Login met Facebook',
    authRegisterWithFacebook: 'Registreren met Facebook',
    inputTitlePlaceholder: 'Titel',
    inputSubtitlePlaceholder: 'Subtitel',
    inputTitleIndication: 'Indicatie',
    inputTitleColor: 'Kleur',
    inputTitleType: 'Type',
    inputTitleIcon: 'Logo',
    inputUploaderPlaceholder: 'Sleep een bestand om te uploaden',
    inputTitleContent: 'Content',
    inputChoose: 'Kies',
    inputInstructionsTitle: 'Gebruikersinstructies',
    inputDescriptionTitle: 'Description',
    inputFeaturesTitle: 'Producteigenschappen',
    inputIndicationsTitle: 'Indicatie',
    inputOrderInfoTitle: 'Bestelinfo',
    inputTitleProtocol: 'Protocol',
    inputDeeplink: 'Deeplink',
    inputTitleIntroduction: 'Welkomtekst',
    inputTitleAttachedProducts: 'Gelinkte products',
    inputTitleAttachedWounds: 'Gelinkte wonden',
    inputTitlePhoto: 'Afbeelding',
    inputGroup: 'Groep',
    inputOptional: '(Optioneel)',
    inputTitleFormats: 'Formats',
    inputProductCombinations: 'Gekoppelde productcombinaties',
    inputAddCombination: 'Combinatie toevoegen',
    avatarAlt: 'Avatar',
    avatarTitle: function (name) { return name; },
    alertModalTitle: 'Bericht',
    alertModalOk: 'Oke',
    alertModalConfirm: 'Bevestig',
    alertModalCancel: 'Annuleren',
    alertModalApply: 'Toepassen op',
    alertModalShowLess: 'Laat minder zien',
    validationEmailError: 'Vul alstublieft uw e-mail adres in.',
    validationEmailValidError: 'Vul alstublieft een geldig e-mail adres in.',
    validationPhoneValidError: 'Vul alstublieft een geldig telefoonnummer in.',
    validationPasswordError: 'Vul alstublieft uw wachtwoord in.',
    validationCodeError: 'Vul alstublieft de validatiecode in die u via e-mail of sms heeft ontvangen.',
    validationPasswordLengthError: 'Uw nieuwe wachtwoord moet minimaal 6 tekens bevatten.',
    validationPasswordConfirmError: 'Uw wachtwoorden komen niet overeen.',
    validationFirstNameError: 'Vul alstublieft uw voornaam in.',
    validationLastNameError: 'Vul alstublieft uw achternaam in.',
    validationCompanyNameError: 'Vul alstublieft de naam van uw bedrijf in.',
    validationPositionNameError: 'U moet een naam voor deze positie invoeren.',
    validationLocationNameError: 'Vul alstublieft de naam in.',
    validationLocationStreetError: 'Vul alstublieft de straat in.',
    validationLocationCityError: 'Vul alstublieft de stad in.',
    validationSelectLocaitonError: 'Selecteer een adres uit uw zoekresultaat om een nieuwe locatie toe te voegen.',
    validationTeamListError: 'Selecteer ten minste één team uit de bovenstaande lijst.',
    validationTeamNameError: 'Vul alstublieft een naam voor dit team in.',
    validationCompanyCode: 'De uitnodigingscode moet 6 tekens lang zijn.',
    validationEventRecurrence: 'De verlengingsdatum moet later zijn dan de huidige vervaldatum.',
    validationHourlyWageError: 'Het uurloon moet geldig zijn.',
    validationMaxHoursError: 'Max. wekelijkse uren moet geldig zijn.',
    validationIndustryType: 'Vul alstublieft het type van uw branche in.',
    validationCompanyType: 'Vul alstublieft het type van uw branche in.',
    validationCodeInvalid: 'De validatiecode is verlopen of ongeldig. Vraag een nieuwe code aan.',
    validationTitleError: 'Voer de titel in.',
    validationContentError: 'Voer de inhoud in.',
    validationAboutError: 'Voer de over tekst in',
    validationAddressError: 'Voer het adres in',
    validationLatitudeError: 'Voer de breedtegraad in',
    validationLongitudeError: 'Voer de lengtegraad in',
    validationOpeningsError: 'Voer de beschikbaarheid in',
    validationIndicationError: 'Voer de indicatie in',
    validationImageError: 'Voeg een afbeelding toe',
    validationSelectError: 'Maak een keuze',
    validationInstructionError: 'Vul de instructie in',
    validationDescriptionError: 'Vul de beschrijving in',
    validationFeaturesError: 'Vul de producteigenschappen in',
    validationIndicationsError: 'Vul de indicatie in',
    validationOrderInfoError: 'Vul de bestelinfo in',
    validationProtocolError: 'Vul de protocol in',
    validationFeaturedError: 'Maak een keuze',
    validationFormatError: 'Voeg format toe',
    validationWoundTypeError: 'Selecteer een wondtype',
    headerBarLogOut: 'Uitloggen',
    sideBarWelcome: 'Welkom,',
    sideBarProfile: 'Mijn profiel',
    sideBarHome: 'Home',
    sideBarSettings: 'Instellingen',
    sideBarHelp: 'Help',
    sideBarCopyright: "\u00A9 WondAdviseur, " + new Date().getFullYear(),
    sideBarAdmins: 'Beheerders',
    sideBarProducts: 'Producten',
    sideBarProductsGuide: 'Productwijzer',
    sideBarPushNotifications: 'Pushmeldingen',
    sideBarWounds: 'Sub wondtype',
    sideBarMedias: 'Media',
    sideBarModels: 'WCS Model',
    sideBarVision: 'Onze visie',
    sideBarReferences: 'Referenties',
    sideBarExtras: 'Extras',
    sideBarHygienes: 'WH Model',
    loginViewEmailPlaceholder: 'E-mailadres',
    loginViewPasswordPlaceholder: 'Wachtwoord',
    loginViewRememberMe: 'Onthoud mij?',
    loginViewSignIn: 'Inloggen',
    loginViewNewUser: 'Nieuwe gebruiker',
    loginViewEmployeeAlert: 'Dit consolepaneel is alleen beschikbaar voor beheerders.',
    loginByContinuingYouAccept: 'Door uw account aan te maken, accepteert u ',
    loginViewTermsAndConditions: 'WondAdviseur\'s Algemene voorwaarden.',
    loginErrorLogin: 'Deze combinatie van e-mail en wachtwoord komt niet overeen met een bestaand account.',
    loginErrorLocked: 'Het account is vergrendeld. Probeer het over 10 minuten opnieuw.',
    loginLogoutMember: 'Terug naar inloggen',
    homeTitle: 'Home',
    homePhone: 'Telefoon',
    homeAbout: 'Over',
    homeAddress: 'Adres',
    homeLongitude: 'Longitude',
    homeLatitude: 'Latitude',
    homeOpenings: 'Wij zijn bereikbaar',
    homeVision: 'Onze visie',
    homeFeatured: 'Uitgelichte producten',
    actionYes: 'Ja',
    actionNo: 'Nee',
    actionDelete: 'Verwijderen',
    actionCreate: 'Aanmaken',
    actionUpdate: 'Aanpassen',
    actionSend: 'Sturen',
    actionRefresh: 'Verversen',
    settingsTitle: 'Instellingen',
    settingsEdit: 'Bewerk',
    settingsSave: 'Opslaan',
    settingsOptional: 'optioneel',
    homeSearch: 'Zoeken',
    homeSearchFor: function (type) { return "Voer de naam in van de " + type; },
    homeSearchForOffer: 'Zoek een aanbieding',
    homeSearchLocation: 'Selecteer een locatie',
    homeLatestOffers: 'Laatste aanbiedingen',
    homeFooterRights: 'WondAdviseur.nl - Alle rechten voorbehouden',
    homeInitiative: 'Initiatief van',
    homeSupport: 'Supported by',
    adminsTitle: 'Beheerders',
    adminsDeleteUserSummary: 'Weet u zeker dat u deze admin wilt verwijderen?',
    adminsEmail: 'E-mailadres',
    adminsFirstName: 'Voornaam',
    adminsLastName: 'Achternaam',
    adminsFirstNamePlaceholder: 'Voornaam (optioneel)',
    adminsLastNamePlaceholder: 'Achternaam (optioneel)',
    adminsAction: 'Actie',
    adminsCreateTitle: 'Maak een nieuwe admin',
    customersTitle: 'Klanten',
    pushNotificationsTitle: 'Pushmeldingen',
    pushNotificationsSendTitle: 'Pushbericht verzenden',
    pushNotificationsConfirm: 'Weet u zeker dat u dit pushbericht naar alle gebruikers wilt sturen?',
    pushNotificationsFormTitle: 'Title',
    pushNotificationsFormContent: 'Inhoud',
    productsTitle: 'Producten',
    productsItemTitle: 'Titel',
    productsSubtitle: 'Subtitel',
    productsAction: 'Actie',
    productsCreateTitle: 'Nieuw product aanmaken',
    productsUpdateTitle: 'Product aanpassen',
    productsGroupCreateTitle: 'Nieuwe groep aanmaken',
    productsGroupUpdateTitle: 'Groep aanpassen',
    productsDeleteSummary: 'Weet u zeker dat u dit product wilt verwijderen?',
    productsDeleteGroupSummary: 'Weet u zeker dat u deze productgroep wilt verwijderen?',
    productsGroupTitle: 'Product groepen',
    productsFormatFormat: 'Format',
    productsFormatAmount: 'Aantal',
    productsFormatOrder: 'Bestelnr.',
    productsFormatIndex: 'ZI-nr.',
    woundsTitle: 'Wondtypes',
    woundsItemTitle: 'Titel',
    woundsSubtitle: 'Subtitel',
    woundsAction: 'Actie',
    woundsCreateTitle: 'Maak nieuw wondtype',
    woundsUpdateTitle: 'Wondtype aanpassen',
    woundsDeleteSummary: 'Weet u zeker dat u dit wondtype wilt verwijderen?',
    woundsItemImage: 'Afbeelding',
    woundsSubTitle: 'Sub wondtypes',
    woundsSubCreateTitle: 'Maak nieuw sub wondtype',
    woundsSubUpdateTitle: 'Sub wondtype aanpassen',
    woundsSubDeleteSummary: 'Weet u zeker dat u dit sub wondtype wilt verwijderen?',
    mediasTitle: 'Media',
    mediasAction: 'Actie',
    mediasDeleteSummary: 'Weet u zeker dat u deze afbeelding wilt verwijderen?',
    mediasItemImage: 'Afbeelding',
    mediasItemUrl: 'Url',
    modelsTitle: 'WCS Model',
    modelsItemTitle: 'Titel',
    modelsSubtitle: 'Subtitel',
    modelsAction: 'Actie',
    modelsCreateTitle: 'Maak nieuw model',
    modelsUpdateTitle: 'Model aanpassen',
    modelsDeleteSummary: 'Weet u zeker dat u dit model wilt verwijderen?',
    modelsIfInfected: 'Indien geïnfecteerd',
    hygienesTitle: 'WH Model',
    hygienesItemTitle: 'Titel',
    hygienesSubtitle: 'Subtitel',
    hygienesAction: 'Actie',
    hygienesCreateTitle: 'Maak nieuw model',
    hygienesUpdateTitle: 'Model aanpassen',
    hygienesDeleteSummary: 'Weet u zeker dat u dit model wilt verwijderen?',
    hygienesIfInfected: 'Indien geïnfecteerd',
    black: 'Zwart',
    yellow: 'Geel',
    red: 'Rood',
    infected: 'Geïnfecteerd',
    dry: 'Droog',
    damp: 'Vochtig',
    wet: 'Nat',
    extrasCreateTitle: 'Maak nieuw item',
    extrasUpdateTitle: 'Item aanpassen',
    extrasDeleteSummary: 'Weet je zeker dat je dit item wilt verwijderen?',
};
export default data;
